import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'

import LessonsPicker from 'views/modals/lessons_picker_modal'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import binderActions from 'redux/actions/binderActions'
import { localize } from 'helpers/translator'

class BinderLessonsPickerModal extends React.Component {

	componentDidMount() {
		this.props.actions.initSearchLessons()
	}

	searchLessons() {
		this.props.actions.searchLessons()
	}

	render() {
		return (
			<LessonsPicker
				closeModal={this.props.actions.cancel}
				modalName={this.props.modalName}
				title={localize('binders_lessons_picker_search_title')}
				folderName={this.props.folderName}
				searchLessons={this.props.actions.searchLessons}
				saveLessons={this.props.actions.selectLessons}
				placeholder={localize('binders_lessons_picker_search_placeholder')}
				cancel={this.props.actions.cancel} />
		)
	}
}

BinderLessonsPickerModal.propTypes = {
	modalName: PropTypes.string,
	entityUID: PropTypes.string,
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		searchLessons: binderActions.searchLessons,
		selectLessons: binderActions.selectLessons,
		initSearchLessons: binderActions.initSearchLessons,
		saveLessons: binderActions.saveLessons,
		cancel: binderActions.lessonsPickerCancel,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(BinderLessonsPickerModal)
